import React, {
  useRef,
  useEffect,
  useState,
  forwardRef,
  useImperativeHandle,
} from "react";
import SearchPanel, { ValueChangedEvent } from "@widgets/SearchPanel";
import { callApi, fnGetDataSet } from "@shared/api/restApi";
import { getInitFormData } from "@shared/utils/CommonUtils";
import { global } from "@shared/libs/Global";

import SnGrid from "@shared/components/GridV2/SnGrid";
import { SnGridRef } from "@shared/components/GridV2/SnGridTypes";
import { menuInfo } from "@shared/type/CommonType";
import { showDialog } from "@widgets/CommonDialog";

interface Props {
  Menuprops: menuInfo;
}

const SN_COS_BAS_REG_001 = forwardRef(({ Menuprops }: Props, ref) => {
  const gridRef = useRef<SnGridRef>(null);
  const searchRef = useRef<any>(null);
  const searchTimerRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const [formData, setFormData] = useState<any>();
  const [formControlData, setFormControlData] = useState<any[]>([]);
  const [columns, setColums] = useState<any[]>([]);
  const [headerInfo, setHeaderInfo] = useState<any>({ controls: [], data: {} });
  const [dataSource1, setDataSource1] = useState<any[]>([]); // 초기값을 빈 배열로 설정
  const { userInfo } = global();

  useEffect(() => {
    const fetchform = async () => {
      try {
        // 평가기간 기본값 = 최신 마감월(공통 메타 쿼리)
        const _rtnYm: any = await fnGetDataSet({
          id: "com_CommonMapper_12",
          params: { cd_firm: userInfo.cd_firm, cd_biz: userInfo.cd_biz },
        });
        const _dt = Array.isArray(_rtnYm?.[0]) ? _rtnYm[0] : [];
        const newData = _dt?.[0]
          ? { dt_from: _dt[0].ym_start, dt_to: _dt[0].ym }
          : {};
        const rtn: any = await getInitFormData();
        setFormData({ ...rtn.formData, ...newData });
        setFormControlData(rtn.formControlData);
        setColums(rtn.grid.grid1);
        setHeaderInfo(rtn.header?.grid1 ?? { controls: [], data: {} });
      } catch (error) {}
    };
    fetchform();
    return () => {
      if (searchTimerRef.current) clearTimeout(searchTimerRef.current);
    };
  }, []);

  const onSearch = async () => {
    const searchForm = searchRef.current.getFormdata();
    const ymEnd = searchForm.dt_to.toString().substring(0, 6);

    try {
      const param = {
        id: "sn_cos_bas_reg_001_01",
        params: {
          cd_firm: userInfo.cd_firm,
          cd_biz: userInfo.cd_biz,
          ym_end: ymEnd,
        },
      };
      const data: any = await fnGetDataSet(param);
      setDataSource1(data[0]);
    } catch (error) {}
  };

  useImperativeHandle(ref, () => ({
    onSearch,
  }));

  //#region  Btn
  const onGrid1BtnsClick = async (id: string) => {
    if (id === "btnApply") {
      const cntRtn: any = await fnGetDataSet({
        id: "sn_cos_bas_reg_001_05",
        params: {
          cd_firm: userInfo.cd_firm,
          cd_biz: searchRef.current.getFormdata().cd_biz,
          dt_end: searchRef.current.getFormdata().dt_to,
        },
      });
      const params = cntRtn?.[0] ?? [];

      if (params.length !== 0) {
        if (Number(params[0]["cnt"]) !== 0) {
          const confirm = await showDialog(
            "confirm",
            "이미 처리된 내역이 있습니다. 삭제하고 다시 생성하겠습니까?"
          );
          if (!confirm) return;

          await Aggregate();
        } else {
          await Aggregate();
        }
      }
    }
  };
  const Aggregate = async () => {
    const searchForm = searchRef.current.getFormdata();
    const data = {
      cd_firm: userInfo.cd_firm,
      cd_biz: searchForm.cd_biz,
      // sp_cos_prd_10 은 YYYYMM(6자리)만 허용하므로 6자리로 맞춘다
      ym_start: searchForm.dt_from.toString().substring(0, 6),
      ym_end: searchForm.dt_to.toString().substring(0, 6),
    };
    try {
      const ok = await callApi("SN_COS_BAS_REG_001_Btn", data);
      if (ok?.status) {
        await onSearch();
      }
    } catch (error: any) {}
  };

  const onSearchValueChanged = (event: ValueChangedEvent) => {
    if (event.source !== "popup") return;
    if (event.colId !== "dt_from" && event.colId !== "dt_to") return;

    if (searchTimerRef.current) clearTimeout(searchTimerRef.current);
    searchTimerRef.current = setTimeout(() => {
      searchTimerRef.current = null;
      onSearch();
    }, 0);
  };

  return (
    <div className="h-full flex flex-col">
      <div>
        <SearchPanel
          ref={searchRef}
          data={formData}
          controls={formControlData}
          onValueChanged={onSearchValueChanged}
        ></SearchPanel>
      </div>
      <div className="flex-1 min-h-0 mt-1">
        <SnGrid
          ref={gridRef}
          columnConfig={columns} // 컬럼 설정 전달
          rowData={dataSource1}
          etcProps={{
            rowSelection: "multiple",
            isEditable: false,
            title: "생산량집계",
          }}
          headerInfo={headerInfo}
          events={{ onBtnEtcClick: onGrid1BtnsClick }}
        />
      </div>
    </div>
  );
});

export default React.memo(SN_COS_BAS_REG_001);
